<template>
  <div>
    <div :class="`container pd-0-f ${$store.state.app.activeGroup.id==9358 ? 'bg-parl-top':''}`">
      <header id="header" :class="`navbar navbar-header ${$store.state.app.activeGroup.id==9358 ? 'bg-parl':''}`">
        <a id="mainMenuOpen" class="burger-menu " @click="mainMenuOpen">
          <feather type="menu"></feather>
          <div class="df-logo">
            <img
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              alt
              class="mg-l-10"
              style="max-width: 40px"
            />
            <span class="mg-l-5" v-html="$store.state.app.activeGroup.name"></span>
          </div>
        </a>

        <div class="navbar-menu-wrapper">
          <div v-if="$store.state.app.isMobile" class="navbar-menu-header">
            <router-link
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: { id: $store.state.app.homePageId, cid: 0 }
              }"
              class="mg-r-10 df-logo"
            >
              <img
                :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
                alt
                class
                style="max-width: 40px"
              />
              <span class="mg-l-5" v-html="$store.state.app.activeGroup.name"></span>
            </router-link>
          </div>
          <div v-else class="navbar-brand" style="padding-left: 7px">
            <router-link
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: { id: $store.state.app.homePageId, cid: 0 }
              }"
              class="mg-r-10"
            >
              <img
                :src="`${myResBaseUrl}media/logo/soyombo_blue.png`"
                alt
                class="df-logo"
                style="max-width: 20px; margin-top: -4px; border-radius: 1px"
              />
            </router-link>
            <h1 style="font-size: 1.1rem" class="d-none d-xl-block mg-b-0">
              <router-link
                :to="{
                  name: $store.state.app.activeGroup.publicPage.route,
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="text-center df-logo logo text-uppercase"
                style="color: #00407a; font-size: 16px; letter-spacing: .5px; font-weight: 600; line-height: 1.3 !important;"
                 v-html="$store.state.app.activeGroup.name"></router-link
              >
            </h1>
          </div>

          <div v-if="$store.state.app.isMobile" class="mg-x-10">
            <router-link
              :to="{ name: 'login' }"
              class="btn btn-outline-primary btn-block d-flex justify-content-center"
              type="button"
            >
              <feather type="log-in" class="mg-r-5" size="14"></feather>Нэвтрэх
            </router-link>
          </div>

          <div v-else class="navbar-right">
            <router-link
              :to="{ name: 'login' }"
              class="btn btn-brand-02 d-flex"
              ><feather type="log-in" class="mg-r-5" size="14"></feather
              >Нэвтрэх</router-link
            >
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
// import { request } from "@/api/all";
import { mapActions } from "vuex";
var _ = require("lodash");

export default {
  data() {
    return {
      pages: [],
      activeId: null,
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["handleResponsiveLayoutConfig"]),
    mainMenuOpen() {
      let _obj = this.$store.state.app.responsiveLayout;
      _obj.navbarNavShow = true;
      _obj.backdrop.show = true;
      _obj.backdrop.onCloseEvent = 1;
      _obj.backdrop.removeClassName = "navbar-nav-show";
      this.handleResponsiveLayoutConfig(_obj).then(() => {
        this.toggleBodyClass("addClass", "navbar-nav-show");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0
        ),
        "ord",
        "asc"
      );
      // request({
      //     api: { method: "POST", url: "TaskCore/GetCoreList" },
      //     data: {
      //         skip: 0,
      //         size: 100,
      //         ot: 356,
      //         model:{
      //             isPublic:true
      //         }
      //     },
      //     store: this.$store
      // }).then(res => {
      //     if(res!=false){
      //         this.pages= _.sortBy(res.data.tasks.filter(x => x.i2 == 1 && x.i1 == 0 && x.parentId == 0), "ord", "asc" );
      //         let _home= res.data.tasks.filter(x=>x.st1=='home');
      //         if(_home.length>0){
      //             this.$emit('load-components', _home[0].id);
      //         }
      //     }
      // });
    },
    getSub(p) {
      let pages = _.sortBy(
        this.$store.state.app.pages.filter(
          x => x.i2 == 1 && x.i1 == 0 && x.parentId == p.id
        ),
        "ord",
        "asc"
      );
      return pages;
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      this.activeId = null;
    }
  }
};
</script>

<style>
.bg-parl-top{
  /* border-bottom: 3px solid #19277f;  */
}
/* .bg-parl {
  position: relative;
  background: none !important;
}
.bg-parl::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://res.gosmart.mn/media/bg/ub.svg');
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  opacity: 0.7;
  z-index: 0;
} */
</style>
